import '@aab/sc-aab-icon';
import { FC, forwardRef } from 'react';

export type IconProps = {
  svg: SVGElement;
  size?: number;
  color?: string;
  label?: string;
  slot?: string;
};

export const Icon: FC<IconProps> = forwardRef<HTMLElement, IconProps>(
  (props, ref) => <aab-icon {...props} ref={ref} />
);
